/**
 * Represents the different actions for a customer monthly submission.
 */
export enum CustomerMonthlySubmissionActionModel {
	/**
	 * The submission is approved, and the data is consistent with the customer's historical data.
	 */
	ApprovedWithDataIsInLineWithCustomerHistory = 1,
	/**
	 * The submission is approved, but the data contains outliers, meaning it deviates from the customer's usual patterns.
	 */
	ApprovedWithDataHasOutliers = 2,
	/**
	 * The submission is approved, but the data indicates that it was not expected this month, suggesting a change in the usual submission pattern.
	 */
	ApprovedWithNoLongerExpectedThisMonth = 3,
	/**
	 * The submission is unapproved, indicating that it was rejected or not yet accepted for processing.
	 */
	Unapproved = 4
}
